// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.6005 1.50098L21.9005 3.00098V8.50098C24.9402 12.3285 21.4524 19.9425 14.2086 21.6232C6.96477 23.304 1 19.5 1 15.501C1 14 1.73821 13.1948 3 14C4.26179 14.8052 6.09789 15.6834 7.86054 16.0718C13.2219 17.253 17.9177 14.501 18.6005 8.50098V1.50098Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.23652 15.0718C13.1104 16.253 17.3792 13.501 17.9998 7.50098C17.3224 8.88616 15.9356 11.2042 10.9998 11.501C8.1174 11.6743 5.55121 10.6981 4.81692 10.3485C4.08263 9.99882 3.67962 10.5012 3.89604 11.3748C4.11246 12.2485 5.1552 14.1025 8.23652 15.0718Z"}}]};

const BananaFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'banana-filled',
    ref,
    icon: element,
  },
));

BananaFilledIcon.displayName = 'BananaFilledIcon';

export default BananaFilledIcon;
